const _ = require('lodash');

const Constants = {
	VERSION_NR: 1,

	LANGUAGES: {
		en: { name: 'English' },
		fi: { name: 'Finnish' },
		dk: { name: 'Danish' },
		se: { name: 'Swedish' },
		nl: { name: 'Dutch' },
	},

	CURRENCIES: {
		EUR: { name: 'Euro', symbol: '€' },
		USD: { name: 'US Dollar', symbol: '$' },
		DKK: { name: 'Danish Krone', symbol: 'kr' },
		SEK: { name: 'Swedish Krona', symbol: 'kr' },
		NOK: { name: 'Norwegian Krone', symbol: 'kr' },
		GBP: { name: 'Pound Sterling', symbol: '£' },
		CAD: { name: 'Canadian Dollar', symbol: '$' },
		AUD: { name: 'Australian Dollar', symbol: '$' },
		CHF: { name: 'Swiss Franc', symbol: '₣' },
	},

	DATE_FORMATS: [
		{
			label: 'DD-MM-YYYY',
			value: 'DD-MM-YYYY',
		},
		{
			label: 'MM-DD-YYYY',
			value: 'MM-DD-YYYY',
		},
		{
			label: 'YYYY-MM-DD',
			value: 'YYYY-MM-DD',
		},
		{
			label: 'Use browser settings',
			value: 'environment',
		},
	],

	PER_WEEK_DATE_FORMATS: [
		{ label: 'YYYY Week WW', value: 'GGGG [Week] W' }, // week year and iso week
		{ label: 'W/C Date', value: `[W/C]` }, // week commencing x, x needs to be appended with the correct date format later
	],

	NUMBER_FORMAT_LOCALES: [
		{
			label: '1,234,567.89',
			value: 'en-GB',
		},
		{
			label: '1.234.567,89',
			value: 'de-DE',
		},
		{
			label: '1 234 567,89',
			value: 'de-AT',
		},
		{
			label: '1\'234\'567.89',
			value: 'de-CH',
		},
	],

	MEDIA_TYPES: {
		unknown: { desc: '[Unknown]', id: 0 },
		banner: { desc: 'Banner', id: 1 },
		video: { desc: 'Video', id: 2 },
		native: { desc: 'Native', id: 3 },
		other: { desc: 'Other', id: 4 },
	},

	PAYMENT_TYPES: {
		unknown: { desc: '[Unknown]', id: 0 },
		cpc: { desc: 'CPC', id: 1 },
		other: { desc: 'CPM/Other', id: 2 },
		serverBidding: { desc: 'Open bidding', id: 3 },
		sdkBidding: { desc: 'SDK bidding', id: 4 },
		headerBidding: { desc: 'Header Bidding', id: 5 },
	},
	DEAL_TYPES: {
		unknown: { desc: '[Unknown]', id: 0 },
		open: { desc: 'Open Deal', id: 1 },
		private: { desc: 'Private Deal', id: 2 },
		progGuaranteed: { desc: 'Programmatic Guaranteed', id: 3 },
		other: { desc: 'Other', id: 4 },
		curated: { desc: 'Curated', id: 5 },
	},
	ADVERTISING_CATEGORIES: {
		unknown: { desc: '[Unknown]', id: 0 },
		political: { desc: 'Political', id: 1 },
	},
	CLUSTER_INFO_URL: 'https://cdn.relevant-digital.com/resources/clusters.json',

	USER_ACCESSES: [
		'publisher@audience',
		'publisher@programmatic',
	],
};

Constants.MEDIA_TYPES_BY_ID = _.keyBy(_.entries(Constants.MEDIA_TYPES).map((
	([name, obj]) => ({ name, ...obj })
)), 'id');

Constants.PAYMENT_TYPES_BY_ID = _.keyBy(_.entries(Constants.PAYMENT_TYPES).map((
	([name, obj]) => ({ name, ...obj })
)), 'id');

Constants.DEAL_TYPES_BY_ID = _.keyBy(_.entries(Constants.DEAL_TYPES).map((
	([name, obj]) => ({ name, ...obj })
)), 'id');

Constants.ADVERTISING_CATEGORIES_BY_ID = _.keyBy(_.entries(Constants.ADVERTISING_CATEGORIES).map((
	([name, obj]) => ({ name, ...obj })
)), 'id');

module.exports = Constants;
